export type SetMetrics = {
  metrics: SetMetric[];
};

export const metricEvents = {
  tck_tickets_list_opened: 'tck_tickets_list_opened', // открытие раздела заявки
  tck_tickets_list_requested: 'tck_tickets_list_requested', // запрос списка (реестра)
  tck_tickets_filter_created: 'tck_tickets_filter_created', // создание фильтра
  tck_tickets_filter_deleted: 'tck_tickets_filter_deleted', // удаление фильтра
} as const;

export type MetricEvents = (typeof metricEvents)[keyof typeof metricEvents];

export type SetMetric = {
  event: MetricEvents;
  at: string; // пример формата "2026-01-31 20:31:12"
};
